import React, {useEffect,useState} from 'react';
import {Suspense } from 'react';
import {RouteProps} from "react-router";
import {BrowserRouter, generatePath, Route, useHistory} from "react-router-dom";
import {useAuth} from "../Auth";
import {Logo} from "../Logo";
import {Routes} from "../Routes";
import {_800callLogs, airQualityMonitoring, tracksideMonitoring} from "../Routes/urls";
import {Spacing} from "../Spacing";
import {AirSvg} from './components/AirSvg';
import {Button} from "./components/Button";
import {ButtonProps} from "./components/Button/types";
import {LogsSvg} from './components/LogsSvg';
import {TSMSvg} from "./components/TSMSvg";
import {logout, navigationRoot, root, spanEmail, spanGroup} from "./styles";
import {LogoutSvg} from "./components/LogoutSvg";


//console.log(user);

export const useNavBar = () => React.useContext(NavBarContext);

const PageButton: React.FC<ButtonProps & {
    page: Page;
}> = ({
    page,
    ...rest
}) => {

  const history = useHistory();
  const {currentPage} = useNavBar();
    const handleGoToPage = (page: Page) => {
        switch (page) {
            case "air-quality-monitoring":
                history.push(airQualityMonitoring);
                break;
            case "800-call-logs":
                history.push(_800callLogs);
                break;
            case "trackside-monitoring":
                history.push(tracksideMonitoring);
                break;
        }
    };
    return (
        <Button
            selected={currentPage === page}
            onClick={() => {
                handleGoToPage(page);
            }}
            {...rest}
        />
    )
};


export type Page = "air-quality-monitoring" | "800-call-logs" | "trackside-monitoring";

export interface INavBarContext {
    currentPage: Page | null;
    updatePage: React.Dispatch<React.SetStateAction<Page | null>>;
}

// @ts-ignore
export const NavBarContext = React.createContext<INavBarContext>();


export const NavBar: React.FC = ({
  children,
}) => {

  
  const [currentPage, setCurrentPage] = React.useState<Page | null>(null);

  const {accountInfo,userRole,signOut} = useAuth();
    
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <NavBarContext.Provider value={{
        currentPage,
        updatePage: setCurrentPage,
      }}>
        <div css={root}>
          <Logo/>
          <div css={navigationRoot}>
            <Spacing h={6}/>
	    { accountInfo ? (
		<div css={spanGroup}>
		  <span>
                    Welcome {accountInfo.account.name}
		  </span>
		  <span css={spanEmail}>
		    {userRole}
		  </span>
		</div>) : (<div> Loading ...</div>)}

            <Spacing h={6.75}/>
            {(userRole == "admin" || userRole == "nsmanager") && <React.Fragment>
              <PageButton
                page={"trackside-monitoring"}
                icon={<TSMSvg/>}
                text={"TSM (Trackside Monitoring)"}
              />
            </React.Fragment>}


            <PageButton
              page={"air-quality-monitoring"}
              icon={<AirSvg/>}
              text={"Air Quality Monitoring"}
            />
            
            <PageButton
              page={"800-call-logs"}
              icon={<LogsSvg/>}
              text={"800 Call Logs"}
            />
	    <Spacing h={2} />
	    <div css={spanGroup}>
	    <span css={spanEmail}>
	      Privileged & Confidential -<br/> Prepared at the Request of Counsel
	    </span>
	    </div>
            <Spacing h={4.75}/>

            <Button icon={<LogoutSvg/>} css={logout} text={"Log out"} onClick={signOut()}/>
          </div>
        </div>
        {children}
      </NavBarContext.Provider>
    </Suspense>
  );
};
